import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Form, ListItem, Text } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useProviderPackage'

import { ProviderPackageModel } from '@models/providerPackage'

type InvoicePayloadProps = {
  providerPackage: ProviderPackageModel,
}

const LinkedBookingAndPackages = (props: InvoicePayloadProps) => {
  const { providerPackage } = props

  const { title } = providerPackage || {}

  const { editProviderPackageUrl } = generateUrls(providerPackage)

  return (
    <ListItem
      boxProps={{
        fontSize: 'small',
        borderBottom: '1px solid',
        padding: 'large',
        as: 'a',
      }}
      href={`${editProviderPackageUrl}?redirect=${generateRedirectUrl()}`}
      showAngleIcon
    >
      <Form.Field
        label="Package"
        labelProps={{ style: { alignItems: 'center', padding: 'large' } }}
      >
        <Text fontSize="small">
          {title}
        </Text>
      </Form.Field>
    </ListItem>
  )
}
export default LinkedBookingAndPackages
